import React from 'react'

const Loader = () => {
  return (
    <div className='loading'>
      <div></div><p>Loading</p>
    </div>
  )
}

export default Loader
